import { useRequest } from 'ahooks';
import { useEffect } from 'react';
import { ServiceBasic, useReadyInfo } from '@/providers/ReadyProvider';
import { fetchServiceBasic } from '@/services/site';

/**
 * 获取服务下拉框数据
 * - service_status 服务状态
 * - service_type 服务项目
 */
const useServiceBasic = () => {
  const { serviceBasic, setServiceBasic } = useReadyInfo();

  const { run: getServiceBasic, data, loading } = useRequest(fetchServiceBasic, { manual: true });

  useEffect(() => {
    if (!serviceBasic || !serviceBasic?.service_status || !serviceBasic?.service_type) {
      getServiceBasic().then((res) =>
        setServiceBasic({
          service_status:
            Object.entries(res?.service_status ?? {})?.map((item) => {
              return {
                label: item[1],
                value: JSON.parse(item[0]),
              };
            }) ?? [],
          service_type:
            Object.entries(res?.service_type ?? {})?.map((item) => {
              return {
                label: item[1],
                value: JSON.parse(item[0]),
              };
            }) ?? [],
        })
      );
    }
  }, [serviceBasic]);

  return {
    data:
      serviceBasic ||
      ({
        service_status:
          Object.entries(data?.service_status ?? {})?.map((item) => {
            return {
              label: item[1],
              value: JSON.parse(item[0]),
            };
          }) ?? [],
        service_type:
          Object.entries(data?.service_type ?? {})?.map((item) => {
            return {
              label: item[1],
              value: JSON.parse(item[0]),
            };
          }) ?? [],
      } as ServiceBasic),
    loading,
  };
};

export default useServiceBasic;
